import { render, staticRenderFns } from "./serviceMenu.vue?vue&type=template&id=03060130"
import script from "./serviceMenu.vue?vue&type=script&lang=js"
export * from "./serviceMenu.vue?vue&type=script&lang=js"
import style0 from "./serviceMenu.vue?vue&type=style&index=0&id=03060130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports